import { render, staticRenderFns } from "./MyComplaints.vue?vue&type=template&id=a36e0734&scoped=true&"
import script from "./MyComplaints.vue?vue&type=script&lang=js&"
export * from "./MyComplaints.vue?vue&type=script&lang=js&"
import style0 from "./MyComplaints.vue?vue&type=style&index=0&id=a36e0734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36e0734",
  null
  
)

export default component.exports